import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../store/selectors/dealershipSelector'
import { useQuery } from 'react-query'
import request from '../../request'
import { CustomerSource } from '../../../lib/types/CustomerSource'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useGetCustomerSources = () => {
  const dealership = useDealership()

  return useQuery<CustomerSource[], Error>(
    ['dealership', dealership?.id, 'customers', 'sources'],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources`,
        method: 'GET',
        signal,
      }),
    {
      enabled: !!dealership?.id,
    },
  )
}
